// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__4gztZ","col":"CardReaderDesc_col__1QdBh","label":"CardReaderDesc_label__1HQEl"};